

















import Vue from 'vue';
import { IOfferArrayItem } from '../../types';
import Helpers from '../../mixins/helpers';

export default Vue.extend({
	name: 'CarOffer', 
	props: ['pillText', 'data'],
	computed: {
		offerType(): string {
			return this.$props.data?.offerType.toString() || '-1';
		}, 
		ends(): string {
			if (!this.$props.data) return '';
			const d = new Date(this.$props.data.validTo);
			const dArr1 = d.toISOString().split('T');
			const dArr2 = dArr1.length ? dArr1[0].split('-') : [];
			const dStr = dArr2.length == 3 ? `${dArr2[2]}/${dArr2[1]}/${dArr2[0]}` : '';
			return dStr ? `Offer ends ${dStr}` : '';
		}, 
		price(): string {
			return this.$props.data?.price ? Helpers.formatPrice(this.$props.data.price) : '';
		}, 
		offerArray(): Array<IOfferArrayItem> {
			if (!this.$props.data) return [];
			const main = [{
				name: this.$props.data.main.name,
				heading: this.replaceDisclaimerSymbol(this.$props.data.main.heading),
				body: this.replaceDisclaimerSymbol(this.$props.data.main.body)
			}];
			const submain = this.$props.data.inclusions.map((o: any) => {
				return {
					name: o.name,
					heading: this.replaceDisclaimerSymbol(o.heading),
					body: this.replaceDisclaimerSymbol(o.body)
				};
			});
			const arr = main.concat(submain);
			return arr; 
		}, 
		priceDisclaimer(): string {
			if (!this.$props.data || !this.$props.data.disclaimers.length) return '';
			const firstOpenSquare = this.$props.data.main.heading.indexOf('[');
			const firstCloseSquare = this.$props.data.main.heading.indexOf(']');
			const hasFirstDisclaimerInHeading = firstOpenSquare != -1 && firstCloseSquare != -1;
			const disclaimerSymbolFromHeading = hasFirstDisclaimerInHeading ? this.$props.data.main.heading.substring(firstOpenSquare, firstCloseSquare+1) : this.$props.data.disclaimers[0].Key;
			const isDisclaimerValid = !!this.$props.data.disclaimers.filter((o: any) => `[${o.Key}]` == disclaimerSymbolFromHeading).length;
			return `${isDisclaimerValid ? disclaimerSymbolFromHeading : ''}`;
		}
	},
	methods: {
		replaceDisclaimerSymbol(txt: string): string {
			return txt.replace(/\[/g, '<sup>[').replace(/\]/g, ']</sup>');
		}
	}
});
